var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 18C34 21.1645 33.0616 24.2579 31.3035 26.8891C29.5454 29.5203 27.0466 31.5711 24.1229 32.7821C21.1993 33.9931 17.9823 34.3099 14.8786 33.6926C11.7749 33.0752 8.92394 31.5513 6.6863 29.3137C4.44866 27.0761 2.92481 24.2251 2.30744 21.1214C1.69008 18.0177 2.00693 14.8007 3.21793 11.8771C4.42894 8.95345 6.4797 6.45459 9.11088 4.69649C11.7421 2.93838 14.8355 2 18 2C22.2435 2 26.3131 3.68571 29.3137 6.68629C32.3143 9.68687 34 13.7565 34 18ZM25.59 16.5H19.5V10.41C19.5 10.0122 19.342 9.63064 19.0607 9.34934C18.7794 9.06803 18.3978 8.91 18 8.91C17.6022 8.91 17.2207 9.06803 16.9393 9.34934C16.658 9.63064 16.5 10.0122 16.5 10.41V16.5H10.41C10.0122 16.5 9.63065 16.658 9.34935 16.9393C9.06804 17.2206 8.91001 17.6022 8.91001 18C8.91001 18.3978 9.06804 18.7794 9.34935 19.0607C9.63065 19.342 10.0122 19.5 10.41 19.5H16.5V25.59C16.5 25.9878 16.658 26.3694 16.9393 26.6507C17.2207 26.932 17.6022 27.09 18 27.09C18.3978 27.09 18.7794 26.932 19.0607 26.6507C19.342 26.3694 19.5 25.9878 19.5 25.59V19.5H25.59C25.9878 19.5 26.3694 19.342 26.6507 19.0607C26.932 18.7794 27.09 18.3978 27.09 18C27.09 17.6022 26.932 17.2206 26.6507 16.9393C26.3694 16.658 25.9878 16.5 25.59 16.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9fdb603a5c2c2f4daceb2195a892785d.svg";
export { ForwardRef as ReactComponent };